const translations = {
    es: {
        "basic": "Básico",
        "advanced": "Avanzado",
        "sender": "Enviar",
        "noData": "No existen configuraciones para los modelos del panel.",
        // -
        "create.title.basic": "Crear configuración de PGA Básico",
        "create.title.advanced": "Crear configuración de PGA Avanzado",
        "edit.title": "Editar configuración de PGA",
        "edit.title.basic": "Editar configuración de PGA Básico",
        "edit.title.advanced": "Editar configuración de PGA Avanzado",
        // - labels
        "label.configs": "Configuraciones",
        "label.aplicated": "Se aplicara la configuración seleccionada a ",
        "label.name": "Nombre",
        "label.model": "Modelo",
        "label.mode": "Modo",
        "label.confirmations": "Confirmaciones",
        "label.date": "Fecha",
        "label.updated": "Actualizado",
        "label.status": "Estado",
        "label.queue": "Cola",
        "label.format": "Formato",
        "label.command": "Comando",
        "label.devices": "dispositivos",
        "label.cancel": "Cancelar",
        "label.closed": "Cerrar",
        "label.description": "Descripción",
        "label.sended": "Enviado",
        "label.confirm": "Confirmado",
        "label.device": "Dispositivo",

        // data
        "format.choice.b": "Básico",
        "format.choice.a": "Avanzado",
        "state.choice.p": "Pendiente",
        "state.choice.s": "Enviado",
        "state.choice.e": "Finalizado",
        "confirm.sent.short": "E",
        "confirm.confirmed.short": "C",

        "command.0": "Lectura",
        "command.1": "Escritura",
        "command.3": "Pendiente",
        // - Filters
        "filter.select.option": "Seleccionar una opción",
        "filter.search": "Buscar",
        "filter.search.placeholder": "uuid, uid",
        "filter.label.status": "Estado",
        "filter.label.model": "Modelo",
        "filter.label.device_group": "Grupos",
        // - Messages
        "messages.title.select-configuration": "No se ha seleccionado una configuración",
        "messages.content.select-configuration": "Se debe seleccionar una configuración",
        "messages.title.send": "Enviado",
        "messages.content.send": "Se ha enviado las configuraciones",
        "messages.title.send-error": "Error",
        "messages.content.send-error": "Se ha producido un error al enviar las configuraciones."
    },
    en: {
        "basic": "Basic",
        "advanced": "Advanced",
        "sender": "Send",
        "noData": "There are no configurations for the panel models.",
        // - titles
        "create.title.basic": "Create PGA basic configuration",
        "create.title.advanced": "Create PGA advanced configuration",
        "edit.title": "Edit PGA configuration",
        "edit.title.basic": "Edit PGA basic configuration",
        "edit.title.advanced": "Edit PGA advanced configuration",
        // - Table
        "label.configs": "Configs",
        "label.aplicated": "The selected configuration will be applied to ",
        "label.name": "Name",
        "label.model": "Model",
        "label.mode": "Mode",
        "label.confirmations": "Confirmations",
        "label.date": "Date",
        "label.updated": "Updated",
        "label.status": "Status",
        "label.queue": "Queue",
        "label.format": "Format",
        "label.command": "Command",
        "label.devices": "devices",
        "label.cancel": "Cancel",
        "label.closed": "Close",
        "label.description": "Description",
        "label.sended": "Sent",
        "label.confirm": "Confirmed",
        "label.device": "Device",
        // data
        "confirm.sent.short": "S",
        "confirm.confirmed.short": "C",
        "command.0": "Read",
        "command.1": "Write",
        "command.3": "Pending",
        // - Filters
        "filter.select.option": "Select an option",
        "filter.search": "Search",
        "filter.search.placeholder": "uuid, uid",
        "filter.label.status": "Status",
        "filter.label.model": "Model",
        "filter.label.device_group": "Device groups",
        // - Messages
        "messages.title.select-configuration": "No configuration selected",
        "messages.content.select-configuration": "Select a configuration",
        "messages.title.send": "Sent",
        "messages.content.send": "The configurations have been sent",
        "messages.title.send-error": "Error",
        "messages.content.send-error": "An error occurred while sending the configurations."

    },
};

export default translations;
